<template>
	<vue-final-modal v-slot="{ params, close }" v-bind="$attrs" classes="modal fade show" content-class="modal-dialog" :click-to-close="false">
		<div class="modal-content">
			<div class="modal-header py-2">
				<h1 class="modal-title fs-5">{{$t('header.exam-students-add')}}</h1>
				<button type="button" class="btn-close" @click="$emit('cancel', close)" aria-label="Close"></button>
			</div>
			<div class="modal-body">
				<div class="text-center" v-if="loading">
					<loading-spinner
						:overlay="loading"
						:text="$t('text.loading-data')"
					></loading-spinner>
				</div>
				<div v-else>
					<ul class="nav nav-tabs mb-2">
						<li class="nav-item" v-if="group_id">
							<a class="nav-link" :class="{'active': action == 'group'}" @click="onToggleTab('group')" href="javascript://">{{$t('btn.from-group')}}</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" :class="{'active': action == 'text'}" @click="onToggleTab('text')" href="javascript://">{{$t('btn.manually')}}</a>
						</li>
					</ul>
					<form v-if="action == 'group'" role="form" @submit.prevent="onAddFromGroup(close)">
						<div>
							<label class="form-label">
								{{$t('text.group-students')}}:
								<font-awesome-icon :icon="['fas', 'spinner']" spin class="ms-2" v-if="loading2" />
							</label>
							<div class="form-check" v-for="student in students" :key="student.id" v-if="!loading2">
								<label class="form-check-label">
									<input class="form-check-input" type="checkbox" v-model="student.checked" />
									<span>{{student.fio}}</span>
								</label>
							</div>
							<div class="alert alert-info mb-0" v-if="!loading2 && students.length <= 0">{{$t('text.students-list-for-add-empty')}}</div>
						</div>
						<button type="submit" ref="addFromGroupSubmit" class="d-none"></button>
					</form>
					<form v-show="action == 'text'" role="form" @submit.prevent="onAddFromText(close)">
						<label for="input-fios" class="form-label">{{$t('text.students-fios-via-enter')}}:</label>
						<textarea id="input-fios" ref="fios" rows="3" :placeholder="$t('text.students-fios-via-enter')" class="form-control" v-model="fios" required></textarea>
						<button type="submit" ref="addFromTextSubmit" class="d-none"></button>
					</form>
				</div>
				<div class="alert alert-warning alert-dismissible fade show mt-2 mb-0" v-if="error">
					{{error}}
					<button type="button" class="btn-close" aria-label="Close" @click="error = ''"></button>
				</div>
			</div>
			<div class="modal-footer p-1">
				<button type="button" @click="onAdd()" class="btn btn-primary" :disabled="loading || (action == 'group' && (!group_id || students.filter(el => el.checked).length <= 0))">{{$t('btn.add')}}</button>
				<button type="button" class="btn btn-outline-secondary" @click="$emit('cancel', close)">{{$t('btn.cancel')}}</button>
			</div>
		</div>
	</vue-final-modal>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';
import autosize from 'autosize';

import LoadingSpinner from '@/components/LoadingSpinner';

export default {
	mixins: lib.mixins,
	inheritAttrs: false,
	//emits: ['confirm', 'cancel']
	data: () => ({
		action: 'group',
		
		group_id: null,
		
		fios: '',
		
		students: [],
		
		error: '',
		loading: false,
		loading2: false,
	}),
	methods: {
		async loadGroupStudents(){
			this.loading2 = true;
			this.error = '';
			let ret = await this.appModel.doGetStudentsWithoutExam(this.group_id, this.$vfm.modals[0].params._value.exam_id);
			if(ret.success){
				this.students = ret.list.map(el => {
					el.checked = true;
					return el;
				});
			}
			this.loading2 = false;
		},
		
		onToggleTab(tab){
			if(!this.loading){
				this.action = tab;
				
				if(tab == 'text'){
					setTimeout(() => {
						this.$refs.fios.focus();
					}, 300);
				}
			}
		},
		
		onAdd(){
			switch(this.action){
				case 'group':
					this.$refs.addFromGroupSubmit.click();
					break;
				case 'text':
					this.$refs.addFromTextSubmit.click();
					break;
			}
		},
		
		async onAddFromGroup(close){
			this.loading = true;
			this.error = '';
			
			for(const student of this.students.filter(el => el.checked)){
				await this.appModel.doAddExamStudent(this.$vfm.modals[0].params._value.exam_id, {
					fio: student.fio,
				});
			}
			this.$emit('add', close);
			
			this.loading = false;
		},
		
		async onAddFromText(close){
			this.loading = true;
			this.error = '';
			
			const fios = this.fios.trim().split('\n');
			if(fios.length > 0){
				for(const fio of fios){
					if(fio.trim()){
						await this.appModel.doAddExamStudent(this.$vfm.modals[0].params._value.exam_id, {
							fio: fio.trim(),
						});
					}
				}
				this.$emit('add', close);
			} else {
				this.$emit('cancel', close);
			}
			this.loading = false;
		},
	},
	async mounted(){
		this.group_id = this.$vfm.modals[0].params._value.group_id;
		if(!this.group_id){
			this.onToggleTab('text');
		} else {
			await this.loadGroupStudents();
		}
		
		setTimeout(() => {
			autosize(this.$refs.fios);
			this.$refs.fios.focus();
		}, 300);
	},
	components: {
		LoadingSpinner,
	},
}
</script>